import React from 'react'
import "../../../styles/ComponentsStyles/Universal/SelectFilter.style.css"
import PropTypes from 'prop-types'

const SelectFilter = ({ setFieldValue, name }) => {

    const last7Days = new Date()
    const last30Days = new Date()
    last7Days.setDate(last7Days.getDate() - 7)
    last30Days.setDate(last30Days.getDate() - 30)
    return (
        <select name={name} id="filter" onChange={(e) => setFieldValue(e.target.value)} >
            <option value={Date()}>Today</option>
            <option value={last7Days}>Last 7 Day</option>
            <option value={last30Days}>Last 30 Day</option>
        </select>
    )
}

export default SelectFilter

SelectFilter.propTypes = {
    name: PropTypes.string.isRequired,
    setFieldValue: PropTypes.func.isRequired,

}